import { render, staticRenderFns } from "./HqHrChengFaPerson.vue?vue&type=template&id=c966185a&scoped=true"
import script from "./HqHrChengFaPerson.vue?vue&type=script&lang=js"
export * from "./HqHrChengFaPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c966185a",
  null
  
)

export default component.exports